export const asyncStatuses = {
    LOADING: "LOADING",
    SUCCESS: "SUCCESS",
    FAILED: "FAILED"
}

export const ThemeEnum = {
    LIGHT: "light",
    DARK: "dark"
}

export const FormModesEnum = {
    ADD: "ADD",
    EDIT: "EDIT",
    VIEW: "VIEW",
    NONE: "NONE",
}